import { SUMMARY_ROW_ID } from '@fourthwall/module-analytics';
export const createChartStatsTableUniqueVisitors = (data) => {
    if (!data)
        return [];
    const statsTableData = data.data.timestamps.map((timestamp, index) => ({
        id: timestamp,
        day: timestamp,
        visitors: data.data.values[index],
    }));
    statsTableData.unshift({
        id: SUMMARY_ROW_ID,
        day: 'Summary',
        visitors: data.aggregatedValue || 0,
    });
    return statsTableData;
};
